module.exports = __webpack_public_path__ + "img/13.0f6f2583.png";